import React from 'react';

import {toRunsDataQueryConfig} from '../../containers/RunsDataLoader';
import type {PanelSpec} from '../../util/panelTypes';
import {type Query} from '../../util/queryTypes';
import {type VegaPanelConfig} from './common';

const PANEL_TYPE = 'Vega';

function transformQuery(query: Query, config: VegaPanelConfig) {
  // We always disable this query, and instead use our own internal RunsDataLoader.
  // We need to do this because the query we want to run actually depends on another
  // query (the vegaPanelQuery which asks for user configured views from the views
  // table), which depends on the current panel configuration.
  const result = toRunsDataQueryConfig(query, undefined, {panelType: 'Vega'});
  result.disabled = true;
  return result;
}

export const Spec: PanelSpec<typeof PANEL_TYPE, VegaPanelConfig> = {
  type: PANEL_TYPE,
  Component: React.lazy(() => import('./Component')),
  transformQuery,
};
